import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Router } from '@angular/router';
import { baseModulesRoutes } from '@app/config';
import {
  administratorMenu,
  dyplomowanieMenu,
  filesRepositoryMenu,
  financesMenu,
  mojeDaneMenu,
  practicesMenu,
  requestsMenu,
  scholarshipsMenu,
  studiesMenu,
} from '@app/core/menu/menu-elements';
import { IMenuElement } from '@interfaces/menu.interface';
import { UsersService } from '@services/api/administracja/user-access/users.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  currentMenuElems$ = new BehaviorSubject<IMenuElement[]>([]);

  constructor(
    private readonly router: Router,
    private readonly permissionsService: UsersService,
  ) {}

  findNodePath(label: string, nodes: IMenuElement[], path: string[] = []): string[] {
    for (const currentNode of nodes) {
      if (currentNode.label === label) {
        return path;
      } else if (currentNode.children) {
        const result = this.findNodePath(label, currentNode.children, [...path, currentNode.label]);
        if (result && result.length) {
          return result;
        }
      }
    }
    return [];
  }

  hasNode(label: string, nodes: IMenuElement[]): boolean {
    for (const currentNode of nodes) {
      if (currentNode.label === label) {
        return true;
      } else if (currentNode.children) {
        const result = this.hasNode(label, currentNode.children);
        if (result) {
          return result;
        }
      }
    }
    return false;
  }

  setMenuForRole(baseMenuElements: IMenuElement[]): void {
    const modules = Object.values(baseModulesRoutes);
    if (modules.some((item) => this.router.routerState.snapshot.url.startsWith(item))) {
      const menuElements = this.buildMenuStructureOnPermissions(
        baseMenuElements,
        this.permissionsService.permissionsCodes,
      );
      this.currentMenuElems$.next(menuElements);
    } else {
      this.currentMenuElems$.next(baseMenuElements);
    }
  }

  setRoleByMenuId(routeSnapshot: ActivatedRouteSnapshot): void {
    // TODO: roles names from access token
    if (routeSnapshot) {
      const routeData = this.getDeepestRouteNodeData(routeSnapshot);
      const { menuId } = routeData;
      const mapMenuIdToRole = new Map([
        ['administration', administratorMenu],
        ['studies', studiesMenu],
        ['dyplomowanie', dyplomowanieMenu],
        ['practices', practicesMenu],
        ['requests', requestsMenu],
        ['scholarships', scholarshipsMenu],
        ['finances', financesMenu],
        ['filesRepository', filesRepositoryMenu],
        ['mojeDane', mojeDaneMenu],
      ]);

      for (const entry of mapMenuIdToRole.entries()) {
        if (this.hasNode(menuId, entry[1])) {
          this.setMenuForRole(entry[1]);
          return;
        }
      }
    }
  }

  getDeepestRouteNodeData(routeSnapshot: ActivatedRouteSnapshot): Data {
    return routeSnapshot.firstChild ? this.getDeepestRouteNodeData(routeSnapshot.firstChild) : routeSnapshot.data;
  }

  private buildMenuStructureOnPermissions(elems: IMenuElement[], expectedPermissionsCodes: string[]): IMenuElement[] {
    const result: IMenuElement[] = [];
    elems.forEach((elem) => {
      if (expectedPermissionsCodes.includes(elem.expectedPermissionCode)) {
        if (elem.children && elem.children.length) {
          elem.children = this.buildMenuStructureOnPermissions(elem.children, expectedPermissionsCodes);
        }
        result.push(elem);
      }
    });
    return result;
  }
}
